import React from 'react'
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

const Pagination = ({
  currentPage,
  totalPages,
  pageStart,
  pageEnd,
  totalCount,
  itemsPerPage,
  onPageChange,
  onFirstPage,
  onLastPage,
  onPreviousPage,
  onNextPage,
  onItemsPerPageChange,
  showItemsPerPage = true,
  className = ''
}) => {
  // Always show pagination to display total count, even for single page results

  return (
    <div className={`flex items-center justify-between bg-gray-100 border border-gray-300 rounded p-3 ${className}`}>
      {/* Total count */}
      <div className="bg-white px-3 py-1 rounded-full text-sm text-gray-600 border">
        全{totalCount}件
      </div>

      {/* Pagination controls */}
      <div className="flex items-center space-x-1">
        {/* First page button */}
        {currentPage > 0 && (
          <button
            onClick={onFirstPage}
            className="w-8 h-8 flex items-center justify-center bg-gray-300 text-white rounded-full hover:bg-gray-400 transition-colors"
            title="最初のページ"
          >
            <ChevronsLeft className="shrink-0 w-4 h-4" />
          </button>
        )}

        {/* Previous page button */}
        {currentPage > 0 && (
          <button
            onClick={onPreviousPage}
            className="w-8 h-8 flex items-center justify-center bg-gray-300 text-white rounded-full hover:bg-gray-400 transition-colors"
            title="前のページ"
          >
            <ChevronLeft className="shrink-0 w-4 h-4" />
          </button>
        )}

        {/* Page numbers */}
        {Array.from({ length: pageEnd - pageStart + 1 }, (_, i) => pageStart + i).map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
              page === currentPage
                ? 'bg-red-100 border border-red-300 text-red-700 font-bold'
                : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {page + 1}
          </button>
        ))}

        {/* Next page button */}
        {currentPage < totalPages - 1 && (
          <button
            onClick={onNextPage}
            className="w-8 h-8 flex items-center justify-center bg-gray-300 text-white rounded-full hover:bg-gray-400 transition-colors"
            title="次のページ"
          >
            <ChevronRight className="shrink-0 w-4 h-4" />
          </button>
        )}

        {/* Last page button */}
        {currentPage < totalPages - 1 && (
          <button
            onClick={onLastPage}
            className="w-8 h-8 flex items-center justify-center bg-gray-300 text-white rounded-full hover:bg-gray-400 transition-colors"
            title="最後のページ"
          >
            <ChevronsRight className="shrink-0 w-4 h-4" />
          </button>
        )}
      </div>

      {/* Items per page selector */}
      {showItemsPerPage && (
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-600 bg-gray-500 text-white px-3 py-1 rounded">
            表示件数
          </span>
          <select
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
            className="border border-gray-300 rounded px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      )}
    </div>
  )
}

export default Pagination
